import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy, ArrowLeft } from 'lucide-react';
import { SEO } from './SEO';

export function AppLegalDoc({ docTitle, updated, seoTitle, seoDescription, seoPath, testId, children }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid={testId}>
      <SEO title={seoTitle} description={seoDescription} path={seoPath} />

      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#1A1A1A]">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')} data-testid="app-legal-brand">
            <div className="w-8 h-8 bg-[#16A34A] flex items-center justify-center flex-shrink-0" style={{ borderRadius: '50px' }}>
              <Trophy className="h-3.5 w-3.5 text-white" strokeWidth={2.5} />
            </div>
            <div className="leading-none">
              <span className="text-base font-bold tracking-tight font-heading">Turf Umpire</span>
              <span className="hidden sm:block text-[10px] text-neutral-500 font-body mt-0.5">by Web Int Projects</span>
            </div>
          </div>
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-1.5 text-xs text-neutral-500 hover:text-white transition-colors font-body"
            data-testid="app-legal-back-btn"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> Home
          </button>
        </div>
      </nav>

      <div className="pt-28 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <header className="mb-10 border-b border-[#1A1A1A] pb-6">
            <h1 className="text-2xl md:text-3xl font-bold font-heading" data-testid="app-legal-title">{docTitle}</h1>
            <p className="text-[11px] text-neutral-500 font-body mt-2">Last updated {updated}</p>
          </header>
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
}

export const LegalIntro = ({ children }) => (
  <p className="text-sm md:text-[15px] text-neutral-300 font-body leading-relaxed mb-9">{children}</p>
);

export const LegalSection = ({ title, children }) => (
  <section className="mb-7">
    <h2 className="text-base md:text-lg font-bold font-heading text-white mb-2.5">{title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);

export const LegalP = ({ children }) => (
  <p className="text-sm text-neutral-400 font-body leading-relaxed">{children}</p>
);

export const LegalList = ({ items }) => (
  <ul className="space-y-2.5">
    {items.map((it, i) => (
      <li key={i} className="flex items-start gap-2.5">
        <span className="w-1.5 h-1.5 rounded-full bg-[#16A34A]/60 flex-shrink-0 mt-2"></span>
        <span className="text-sm text-neutral-400 font-body leading-relaxed">{it}</span>
      </li>
    ))}
  </ul>
);

export const LegalLink = ({ href, children }) => (
  <a href={href} className="text-[#16A34A] hover:underline break-words">{children}</a>
);

export default AppLegalDoc;
